import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import styled from '@emotion/styled';
import { Container } from 'layouts';

const Article = styled.div`
  background: ${props => props.theme.colors.white.white};
`;

const ImgDiv = styled.div`
  vertical-align: middle;
  height: fit-content;
  object-fit: cover;
  object-position: center;
  overflow: hidden;
  align-content: center;
  img {
    width: 100%;
    overflow: hidden;
    display: block;
  }
`;

const ContentDiv = styled.div`
  min-height: fit-content;
  padding: 2rem 1rem;
  h4, h6 {
    margin: 10px 0 0 0 !important;
  }
  h4 {
    line-height: 1.3;
    margin-bottom: 20px;
    margin-top: 5px;
  }  
  .readtime {
    margin-top: 0;
    color: ${props => props.theme.colors.white.gray};
    font-size: .8rem;
  }
`;

const FeaturedBlogItem = ({ path, cover, title, subtitle, excerpt, readtime }) => (
  <Container>
    <Article>
      <ImgDiv>
        <Link to={path} title={title}>
          <Img fluid={cover} />
        </Link>
      </ImgDiv>
      <ContentDiv>
        <a href={`/blog/${path}`}>
          <h4>{title}</h4>
          {subtitle && <h6>{subtitle}</h6>}
          {readtime && <em className='readtime'>{readtime} min</em>}
        </a>
        <div className='article-description'>{excerpt}</div>
      </ContentDiv>
    </Article>
  </Container>
);

export default FeaturedBlogItem;

FeaturedBlogItem.propTypes = {
  cover: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  readtime: PropTypes.number
};
